import React from 'react';
import { Button, Heading, Stack, Text } from '@chakra-ui/react';
import { AuthStage } from '../..';
import { Title } from '../../../../atoms/Title';

interface IProps {
  appClient: string;
  cognitoDomain: string;
  onLogout: () => void;
  setAuthStage: (stage: AuthStage) => void;
}

const SSOLogout = (props: IProps): React.ReactElement => {
  const { setAuthStage } = props;

  const handleLoginRedirect = (): void => {
    setAuthStage(AuthStage.NONE);
    setTimeout(() => {
      window.location.href = window.location.origin;
    }, 2000);
  };

  const title = 'You were logged out';

  return (
    <>
      <Title title={title} />

      <Heading as="h1" mb="6">
        {title}
      </Heading>

      <Text>Thank you for using CAS Shield.</Text>

      <Stack>
        <Button onClick={handleLoginRedirect} size="lg" variant="solid">
          Log in
        </Button>
      </Stack>
    </>
  );
};

export default SSOLogout;
